import { Spin } from 'antd';
import React from 'react';

import styles from './index.module.scss';

const LoadingSpin = () => {
  return (
    <div className={styles.loadingWrapper}>
      <Spin size="large" className={styles.loadingSpin} />
    </div>
  );
};

export default LoadingSpin;
